import { MenuItem, SelectField } from 'material-ui'
import React from 'react'
import AutoCompleteField from '../AutoCompleteField'

// A single "display condition" row - the same shape used by CMS block
// Display Conditions (see ncfdd-api lib/routes/admin/cms-block-type.js) and
// by session sale discount window conditions. A row with a value on every
// field must match on all of them; multiple rows in a repeater are OR'd
// together by the server.
const ConditionFields = ({ value, onChange }) => {
  return (
    <div>
      <AutoCompleteField
        field={{
          prop: 'title',
          name: 'Title',
          type: 'autocomplete',
          setting: 'titles',
          displayProp: 'name',
          valueProp: 'value'
        }}
        value={value?.title}
        onChange={(v) => onChange({ ...value, title: v })}
      />
      <SelectField
        floatingLabelText='Member Type'
        value={value?.member_type}
        onChange={(_, __, v) => onChange({ ...value, member_type: v })}
      >
        {[
          { name: 'Any', value: 'any' },
          { name: 'Individual Member', value: 'individual_member' },
          { name: 'Institution Member', value: 'institution_member' },
          { name: 'Account Holder', value: 'account_holder' },
          { name: 'Primary Account Holder', value: 'primary_account_holder' }
        ].map((item, i) => (
          <MenuItem key={i} value={item.value} primaryText={item.name} />
        ))}
      </SelectField>
      <AutoCompleteField
        field={{
          prop: 'associated_institution',
          name: 'Associated Institution',
          type: 'autocomplete',
          apiPath: 'admin/institutions',
          displayProp: 'name',
          valueProp: 'id'
        }}
        value={value?.associated_institution}
        onChange={(v) => onChange({ ...value, associated_institution: v })}
      />
      <SelectField
        floatingLabelText='FSP Alumni Status'
        value={value?.fsp_alumni_status}
        onChange={(_, __, v) => onChange({ ...value, fsp_alumni_status: v })}
      >
        {[
          { name: 'Any', value: 'any' },
          { name: 'Alumni', value: 'alumni' },
          { name: 'Non-alumni', value: 'non_alumni' }
        ].map((item, i) => (
          <MenuItem key={i} value={item.value} primaryText={item.name} />
        ))}
      </SelectField>
      <SelectField
        floatingLabelText='Session State'
        value={value?.session_state}
        onChange={(_, __, v) => onChange({ ...value, session_state: v })}
      >
        {[
          { name: 'Any', value: 'any' },
          { name: 'Logged In', value: 'logged_in' },
          { name: 'Logged Out', value: 'logged_out' }
        ].map((item, i) => (
          <MenuItem key={i} value={item.value} primaryText={item.name} />
        ))}
      </SelectField>
    </div>
  )
}

export default ConditionFields
